import formatNumber from "./formatNumber";
export default (exchangeRate, walletAmount, walletCurrency, localAmount, localCurrency) =>
  exchangeRate
    ? `${formatNumber(walletAmount, walletCurrency)} (${formatNumber(localAmount, localCurrency)})`
    : formatNumber(walletAmount, walletCurrency);
